"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * const ftyp - Parses a 'ftyp atom'
 *
 * @param  {Atom} atom          An 'ftyp' Atom
 * @param  {Uint8Array} payload Uint8 array of atom data starting AFTER the 4 byte atom name
 */
var ftyp = function ftyp(atom, payload) {
  var view = new DataView(payload.buffer, 4, 4);
  var majorBrandBytes = payload.slice(0, 4);
  atom.majorBrand = String.fromCharCode.apply(null, majorBrandBytes);
  atom.minorVersion = view.getUint32(0);
  atom.compatibleBrands = [];
  var i = 8;

  while (i < payload.length) {
    var brandSlice = payload.slice(i, i + 4);
    var brandName = String.fromCharCode.apply(null, brandSlice);
    atom.compatibleBrands.push(brandName);
    i += 4;
  }
};

var mvhd = function mvhd(atom, payload) {};

var tkhd = function tkhd(atom, payload) {};

var mdhd = function mdhd(atom, payload) {};

var hdlr = function hdlr(atom, payload) {};

var vmhd = function vmhd(atom, payload) {};

var dref = function dref(atom, payload) {};

var dinf = function dinf(atom, payload) {};

var stco = function stco(atom, payload) {};

var stsz = function stsz(atom, payload) {};

var stsc = function stsc(atom, payload) {};

var stts = function stts(atom, payload) {};

var pasp = function pasp(atom, payload) {};

var colr = function colr(atom, payload) {};
/**
 * const avcc - Parses an 'avcC' type atom
 *
 * @param  {Atom} atom          An 'avcC' type atom
 * @param  {Uint8Array} payload Uint8 array of atom data starting AFTER the 4 byte atom name
 */


var avcC = function avcC(atom, payload) {
  var view = new DataView(payload.buffer, 0, 4);
  atom.version = view.getUint8(0);
  atom.profile = view.getUint8(1);
  atom.profileCompatibility = view.getUint8(2);
  atom.levelIndication = view.getUint8(3);
};

var avc1 = function avc1(atom, payload) {
  var view = new DataView(payload.buffer, 24, 4);
  atom.width = view.getUint16(0);
  atom.height = view.getUint16(2);
};

var stsd = function stsd(atom, payload) {};

var stbl = function stbl(atom, payload) {};

var minf = function minf(atom, payload) {};

var mdia = function mdia(atom, payload) {};

var trak = function trak(atom, payload) {};

var moov = function moov(atom, payload) {};

var trex = function trex(atom, payload) {
  var view = new DataView(payload.buffer);
  atom.version = view.getUint8(0);
  atom.trackID = view.getUint32(4);
};

var mvex = function mvex(atom, payload) {};

var mfhd = function mfhd(atom, payload) {};

var tfhd = function tfhd(atom, payload) {};

var tfdt = function tfdt(atom, payload) {};

var trun = function trun(atom, payload) {};

var traf = function traf(atom, payload) {};

var moof = function moof(atom, payload) {};

var mdat = function mdat(atom, payload) {};

var smhd = function smhd(atom, payload) {};

var mp4a = function mp4a(atom, payload) {};
/**
 * class AudioSpecificConfig holds specifics about the audio decoder config
 *
 * @return {AudioSpecificConfig} A constructed audio specific config
 */


var AudioSpecificConfig = function AudioSpecificConfig(payload) {
  _classCallCheck(this, AudioSpecificConfig);

  this.type = payload[0] >> 3;
  this.frequency = payload[0] << 1;
  this.channelConfig = null;
};
/**
 * const esds - Parses an 'esds' type atom
 *
 * @param  {Atom} atom          An 'esds' type atom
 * @param  {Uint8Array} payload Uint8 array of atom data starting AFTER the 4 byte atom name
 */


var esds = function esds(atom, payload) {
  /// It's an elementary stream.  Chunk it up.
  var chunks = [];
  var currentChunk;

  for (var i = 4; i < payload.length; i++) {
    if (payload[i + 1] == 0x80) {
      if (payload[i + 2] == 0x80) {
        if (payload[i + 3] == 0x80) {
          if (currentChunk) {
            chunks.push(currentChunk);
          }

          currentChunk = [];
        }
      }
    }

    currentChunk.push(payload[i]);
  } // Decoder Config is signaled with 0x04


  var decoderConfig = chunks.map(function (e) {
    if (e[0] == 0x04) {
      return e;
    }
  }).filter(function (e) {
    if (e) {
      return e;
    }
  })[0].slice(4);
  atom.objectProfileIndication = decoderConfig[1]; // Audio Specific Config is signaled with 0x05

  decoderConfig = chunks.map(function (e) {
    if (e[0] == 0x05) {
      return e;
    }
  }).filter(function (e) {
    if (e) {
      return e;
    }
  })[0].slice(4);
  var audioSpecificConfigBytes = decoderConfig.slice(1, 1 + decoderConfig[0]);
  atom.audioSpecificConfig = new AudioSpecificConfig(audioSpecificConfigBytes);
};

var AtomParser = {
  "ftyp": ftyp,
  "mvhd": mvhd,
  "tkhd": tkhd,
  "mdhd": mdhd,
  "hdlr": hdlr,
  "vmhd": vmhd,
  "dref": dref,
  "dinf": dinf,
  "stco": stco,
  "stsz": stsz,
  "stsc": stsc,
  "stts": stts,
  "pasp": pasp,
  "colr": colr,
  "avcC": avcC,
  "avc1": avc1,
  "stsd": stsd,
  "stbl": stbl,
  "minf": minf,
  "mdia": mdia,
  "trak": trak,
  "moov": moov,
  "trex": trex,
  "mvex": mvex,
  "mfhd": mfhd,
  "tfhd": tfhd,
  "tfdt": tfdt,
  "trun": trun,
  "traf": traf,
  "moof": moof,
  "mdat": mdat,
  "smhd": smhd,
  "mp4a": mp4a,
  "esds": esds
  /**
   * Array.prototype.flatMap - flatMap over arrays
   *
   * @param  {Function} lambda Map function
   * @return {Array}        Mapped array flattened with undefined/null removed
   */

};

Array.prototype.flatMap = function (lambda) {
  return Array.prototype.concat.apply([], this.map(lambda)).filter(function (x) {
    if (x) {
      return x;
    }
  });
};

var _default = AtomParser;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/fmp4/atom-parser.js
// module id = 201
// module chunks = 0